import types from './types'

export default {
  setPlaybooks: (playbooks: { playbooks: Playbook[] }) => ({ type: types.SET_PLAYBOOKS, payload: playbooks }),
  setPlaybookPrograms: (payload: { playbook_id: string; programs: Program[] }) => ({
    type: types.SET_PLAYBOOK_PROGRAMS,
    payload,
  }),
}
